import { render, staticRenderFns } from "./NewTruck.vue?vue&type=template&id=1a87a9ce"
import script from "./NewTruck.vue?vue&type=script&lang=ts"
export * from "./NewTruck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports